<template>
  <div>
    <v-row>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.acPower"
          label="Potência AC (kW)"
          v-bind:options="optionsBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          class="my-5"
          v-model="device.acVoltage"
          :items="voltageOptions"
          label="Tensão AC (V)"
          item-text="text"
          item-value="value"
          dense
        >
        </v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          class="my-5"
          v-model="device.acPhases"
          :items="phasesOptions"
          label="Fases"
          item-text="text"
          item-value="value"
          dense
        >
        </v-select>
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.dcMinPower"
          label="Potência Dc. Min.(kWp)"
          v-bind:options="optionsBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.dcMaxPower"
          label="Potência Dc. Max.(kW)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.acMaxCurrent"
          label="Corrente Ac. Max.(A)"
          v-bind:options="optionsBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.efficiency"
          label="Eficiência (%)"
          v-bind:options="optionsBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.weight"
          label="Peso (kg)"
          v-bind:options="optionsBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.height"
          label="Altura (mm)"
          v-bind:options="optionsInteger"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.width"
          label="Largura (mm)"
          v-bind:options="optionsInteger"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.depth"
          label="Profundidade (mm)"
          v-bind:options="optionsInteger"
        />
      </v-col>

      <!-- <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.warranty"
          label="Garantia (anos)"
          v-bind:options="optionsInteger"
        />
      </v-col> -->
    </v-row>
    <v-row>
      <span class="ma-3">Qtd. Mppts: {{ device.mppts.length - 1 }} </span>
      <v-btn class="ma-3 primary" @click="addMppt">+</v-btn>
    </v-row>
    <v-row v-if="device.mppts">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="">Remover</th>
              <th style="" class="text-left">Tensão MPPT mínima (V)</th>
              <th class="text-left">Tensão MPPT máxima (V)</th>
              <th class="">Tensão máxima DC (V)</th>
              <th class="">Corrente máxima (A)</th>
              <th class="">Número máximo de strings</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in device.mppts" :key="item.id">
              <td class="text-right">
                <v-btn @click="removeMppt(index)">
                  <v-icon>mdi-delete</v-icon></v-btn
                >
              </td>
              <td>
                <vuetify-money
                  v-model.number="item.dcMinOpVoltage"
                  v-bind:options="optionsInteger"
                />
              </td>
              <td>
                <vuetify-money
                  v-model.number="item.dcMaxOpVoltage"
                  v-bind:options="optionsInteger"
                />
              </td>

              <td class="text-right">
                <vuetify-money
                  v-model.number="item.dcMaxVoltage"
                  v-bind:options="optionsInteger"
                />
              </td>
              <td class="text-right">
                <vuetify-money
                  v-model.number="item.dcMaxCurrent"
                  v-bind:options="optionsInteger"
                />
              </td>
              <td class="text-right">
                <vuetify-money
                  v-model.number="item.sMax"
                  v-bind:options="optionsInteger"
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>
  </div>
</template>



<script>
export default {
  components: {
    // EditModulo
  },

  name: "edit-inverter",

  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  props: ["device"],
  data() {
    return {
      optionsBr: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      optionsInteger: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 0,
      },
      voltageOptions: [
        { value: 220, text: "220V" },
        { value: 380, text: "380V" },
      ],
      phasesOptions: [
        { value: 1, text: "Monofásico" },
        { value: 3, text: "Trifásico" },
      ],
    };
  },

  methods: {
    addMppt() {
      this.device.mppts.push({
        dcMinOpVoltage: 0, //Min operation voltage
        dcMaxOpVoltage: 0, //Max operation voltage
        dcMaxVoltage: 0,
        dcMaxCurrent: 0,
        sMax: 1,
      });
    },
    removeMppt(index) {
      console.log("remove>" + index);
      this.device.mppts.splice(index, 1);
    },
  },
};
</script>
